import moment from 'moment'

const statusColors = {
  New: 'secondary',
  Confirmed: 'secondary',
  AcceptedByRestaurant: 'info',
  SentToKitchen: 'info',
  Cooking: 'info',
  Cooked: 'info',
  Assembling: 'info',
  Assembled: 'info',
  AtCourier: 'primary',
  OnTheWay: 'primary',
  Delivered: 'success',
  Completed: 'success',
  Cancelled: 'error',
}

export const orderStatusColor = value => statusColors[value] || 'secondary'

export const toCardDateTime = value => (value ? moment(value).format('DD.MM.YYYY HH:mm:ss') : '')

const LATE_SECONDS = 60

export const lateRecordTime = ({ occurredAt, recordedAt }) => {
  if (!occurredAt || !recordedAt) return ''

  const occurred = moment(occurredAt)
  const recorded = moment(recordedAt)

  if (Math.abs(recorded.diff(occurred, 'seconds')) <= LATE_SECONDS) return ''

  return recorded.isSame(occurred, 'day') ? recorded.format('HH:mm:ss') : toCardDateTime(recordedAt)
}
